import Link from 'next/link';
import { Text } from '@pairy/pds-react';

import { URLS } from '@/constants/layout';

const PolicyLinks = () => {
  return (
    <div>
      <Link href={URLS['privacyPolicyPage']}>
        <a target="_blank" rel="noopener noreferrer">
          <Text as="p" color="zinc_400" variant="sm-regular" textAlign="center">
            개인정보 처리 방침
          </Text>
        </a>
      </Link>
      <Link href={URLS['termsOfServicePage']}>
        <a target="_blank" rel="noopener noreferrer">
          <Text
            as="p"
            color="zinc_400"
            variant="sm-regular"
            marginTop={8}
            textAlign="center"
          >
            이용 약관
          </Text>
        </a>
      </Link>
    </div>
  );
};

export default PolicyLinks;
